function a(e, n) {
  e.enableZoom = n, e.enablePan = n, e.enableRotate = n;
}
export {
  a as EnableOrbit
};
//# sourceMappingURL=index8.js.map
